import React from "react";
import LoginContainer from "containers/authentication/login/Login.container";
import Page from "components/common/page/Page.component";

const LoginPage = () => {
  return (
    <Page title="Login">
      <LoginContainer />
    </Page>

  );
};

export default LoginPage;
